<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
        <div class="lg:max-w-detail lg:mr-auto">
          <div class="flex items-center"
            v-if="!modeTemplate"
          >
            <input
              class='k-checkbox !mr-2 checkbox-lg'
              type='checkbox'
              v-model="checkall"
              @click="changeAllCheckbox(!checkall)"
            />
            <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block">Marcar todos los campos</label>
          </div>

          <base-collapsible-form 
            v-if="hasModuleCustomLogo"
            ref="baseCollapsibleLogo" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <div class="flex items-center">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.logo_custom')}}</h2>
                <base-tooltip-icon size="sm" :content="tooltipContentLogo" class="ml-2"/>
              </div>
            </template>
            <template slot="content">

            <div>
              <div class="flex items-center px-2 w-full mb-2">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg '
                  type='checkbox'
                  v-model="valuesCheckbox.fileLight"
                />
                <label class="w-full dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block">{{$t('app.mode_light')}}</label>
              </div>
              <div class="-mx-2">
                <div class="px-2 mb-2 lg:mb-0">
                  <el-form-item prop="fileLight" ref="uploadlogo">
                    <Upload
                      role="button"
                      ref="upload"
                      id="pfxselector"
                      class="bg-white dark:bg-darkblue-900"
                      :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                      drag
                      action="#"
                      accept="image/png,image/webp,image/jpeg"
                      :show-file-list="false"
                      :multiple="false"
                      :auto-upload=false
                      :on-remove="handleRemoveLight"
                      :on-change="handleChangeLight">
                      <i class="el-icon-upload"></i>
                      <p v-if="fileLight.name" class="el-upload__text"><em>{{fileLight.name}}</em></p>
                      <div v-else class="el-upload__text">Suelta tu archivo aquí o <em>haz clic para cargar</em></div>
                    </Upload>
                  </el-form-item>
                  <div class="">
                    <div v-if="validLightImage" class="pb-10 ">
                      <div class="flex items-center gap-x-2 mb-2">
                        <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">
                          {{$t('clients.logo_custom_previsualizacion')}}
                        </label>
                        <base-button-icon 
                          v-if="hasLogoLightSaved" 
                          ariaLabel="Eliminar logo (modo claro)"
                          name="cross" 
                          size="xs" 
                          iconSize="xs" 
                          mode="primary-phantom" 
                          @click="handleRemoveLight"/>  
                      </div>
                      <div v-if="!croppedLight">
                        <Cropper
                          ref="cropperLight"
                          :src="srcImageLight" 
                          :stencil-props="stencilProps"
                        />
                        <div class="w-full flex justify-end mt-4">
                          <base-button 
                            mode="primary" 
                            :text="$t('app.recortar')" 
                            @click="recortarModoClaro" 
                            :loading="isGeneralLoading"/>
                        </div>
                      </div>

                      <div class="flex items-center gap-x-2 mt-1"
                        v-if="croppedLight"
                        >
                        <img 
                          id="logo-custom-client-light" 
                          ref="logo-custom-client-light" 
                          :src="'data:image/png;base64, ' + fileLight.b64" 
                          :alt="$t('clients.logo_custom_light')" 
                          class="w-[304px] h-[78px] border-2 border-solid border-primary-300 dark:bg-white rounded object-scale-down object-left"/>
                      </div>
                    </div>
                    <div v-else class="flex flex-col pb-10 ">
                      <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">Ningún logo seleccionado, se utilizará el predeterminado</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="flex items-center px-2 w-full mb-2">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg '
                  type='checkbox'
                  v-model="valuesCheckbox.fileDark"
                />
                <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block">{{$t('app.mode_dark')}}</label>
              </div>
              <div class="-mx-2">
                <div class="px-2 mb-2 lg:mb-0">
                  <el-form-item prop="fileDark" ref="uploadlogo">
                    <Upload
                      role="button"
                      ref="upload"
                      id="pfxselector"
                      class="bg-white dark:bg-darkblue-900"
                      :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                      drag
                      action="#"
                      accept="image/png,image/webp,image/jpeg"
                      :show-file-list="false"
                      :multiple="false"
                      :auto-upload=false
                      :on-remove="handleRemoveDark"
                      :on-change="handleChangeDark">
                      <i class="el-icon-upload"></i>
                      <p v-if="fileDark.name" class="el-upload__text"><em>{{fileDark.name}}</em></p>
                      <div v-else class="el-upload__text">Suelta tu archivo aquí o <em>haz clic para cargar</em></div>
                    </Upload>
                  </el-form-item>
                  <div class="">
                    <div v-if="validDarkImage" class="pb-10">
                      <div class="flex items-center gap-x-2 mb-2">
                        <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">
                          {{$t('clients.logo_custom_previsualizacion')}}
                        </label>
                        <base-button-icon 
                          v-if="hasLogoDarkSaved" 
                          ariaLabel="Eliminar logo (modo oscuro)"
                          name="cross" 
                          size="xs"
                          iconSize="xs" 
                          mode="primary-phantom" 
                          @click="handleRemoveDark"/>
                      </div>
                        <div v-if="!croppedDark">
                          <Cropper
                            ref="cropperDark"
                            :src="srcImageDark" 
                            :stencil-props="stencilProps"
                          />
                          <div class="w-full flex justify-end mt-4">
                            <base-button 
                              mode="primary" 
                              :text="$t('app.recortar')" 
                              @click="recortarModoOscuro" 
                              :loading="isGeneralLoading"/>
                          </div>
                        </div>

                        <div class="flex items-center gap-x-2 mt-1"
                          v-if="croppedDark"
                          >
                          <img 
                            id="logo-custom-client-dark" 
                            ref="logo-custom-client-dark" 
                            :src="'data:image/png;base64, ' + fileDark.b64" 
                            :alt="$t('clients.logo_custom_dark')" 
                            class="w-[304px] h-[78px] border-2 border-solid border-primary-300 bg-darkblue-800 rounded object-scale-down object-left"/>
                        </div>
                    </div>
                    <div v-else class="flex flex-col pb-10 ">
                      <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">Ningún logo seleccionado, se utilizará el predeterminado</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            v-if="hasModuleCustomColors"
            ref="baseCollapsibleColors" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <div class="flex items-center">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.colors_custom')}}</h2>
                <!-- <base-tooltip-icon size="sm" :content="tooltipContentColors" class="ml-2"/> -->
              </div>
            </template>
            <template slot="content">

              <div class="flex items-center mb-4">
                
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.color"
                  />
                <label v-if="colorSelected" class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mr-2">{{$t('clients.colors_custom_selected')}}</label>
                <label v-else class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mr-2">{{$t('clients.colors_custom_not_selected')}}</label>
               
                <el-color-picker
                  v-model="colorSelected"
                  :predefine="predefineColors">
                </el-color-picker>
                <p class="hidden">{{colorSelected}}</p>
              </div>
              <p v-if="colorSelected" class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 mb-6">
                {{$t('clients.colors_custom_extend')}}
              </p>

            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            v-if="hasModuleCustomSMTPCliente || hasModuleCustomSMTPZerocoma"
            ref="baseCollapsibleCustomMailSmtp" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_smtp')}}</h2>
            </template>
            <template slot="content">

            <div class="mb-4">
              <div class="flex items-center px-2 w-full mb-1">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg '
                  type='checkbox'
                  v-model="valuesCheckbox.Smtp"
                />
                <div class="w-full">
                  <label for="switch-smtp-main" class="text-sm font-semibold text-secondary-600 block flex flex-col">
                    {{$t('smtp.main')}}
                    <span class="sr-only">{{$t('app.options')}}: {{$t('smtp.default')}} / {{$t('smtp.custom')}}</span>
                  </label>
                  <el-switch 
                    id="switch-smtp-main"
                    :aria-label="$t('smtp.main')"
                    class="switch-text break-normal both-switch mt-2" 
                    v-model="form.smtpMain" 
                    :active-text="$t('smtp.custom')"
                    :inactive-text="$t('smtp.default')"
                    inactive-color="var(--primary-800)"
                    />
                </div>
              </div>
            </div>

          <div v-if="form.smtpMain">
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.server')}}
                  <el-form-item prop="smtpServer">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.smtpServer"
                      maxlength='200'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.from')}}
                  <el-form-item prop="smtpFrom">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.smtpFrom"
                      maxlength='100'
                      autocomplete="email"
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.port')}}
                  <el-form-item prop="smtpPort">
                    <el-input
                      clearable
                      class="w-full"
                      v-model.number="form.smtpPort"
                      maxlength='10'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="mb-4">
              <label for="switch-smtp-ssl" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('smtp.ssl')}}
                <span class="sr-only">{{$t('app.inactive')}} / {{$t('app.active')}}</span>
              </label>
              <el-switch 
                id="switch-smtp-ssl"
                :aria-label="$t('smtp.ssl')"
                class="switch-text break-normal both-switch mt-2" 
                v-model="form.smptSSL" 
                :active-text="$t('companies.active')"/>
            </div>
              
            <div class="mb-4">
              <label for="switch-smtp-relay" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('smtp.relay')}}
                <span class="sr-only">{{$t('app.inactive')}} / {{$t('app.active')}}</span>
              </label>
              <el-switch 
                id="switch-smtp-relay"
                :aria-label="$t('smtp.relay')"
                class="switch-text break-normal both-switch mt-2" 
                :disabled="form.smptOAuth2"
                v-model="form.smtpRelay" 
                :active-text="$t('companies.active')"/>
            </div>

            <div class="mb-4">
              <label for="switch-smtp-oauth2" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('smtp.oauth2')}}
                <span class="sr-only">{{$t('app.inactive')}} / {{$t('app.active')}}</span>
              </label>
              <el-switch 
                id="switch-smtp-oauth2"
                :aria-label="$t('smtp.oauth2')"
                class="switch-text break-normal both-switch mt-2" 
                :disabled="form.smtpRelay"
                v-model="form.smptOAuth2" 
                :active-text="$t('companies.active')"/>
            </div>

            <div class="lg:mb-2" v-if="form.smptOAuth2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.clientid')}}
                  <el-form-item prop="smptClientId">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.smptClientId"
                      maxlength='100'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2" v-if="form.smptOAuth2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.tenantid')}}
                  <el-form-item prop="smptTenantId">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.smptTenantId"
                      maxlength='100'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2" v-if="!form.smtpRelay">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.user')}}
                  <el-form-item prop="smtpUser">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.smtpUser"
                      maxlength='100'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2" v-if="!form.smtpRelay">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.pass')}}
                  <el-form-item prop="smtpPass">
                    <el-input
                      ref="passwordInputPassPersonalizationTemplate"
                      :disabled="disableEditPass"
                      clearable
                      show-password
                      class="w-full"
                      v-model="form.smtpPass"
                      autocomplete="new-password"
                      maxlength='100'
                    >
                      <base-button-icon
                        v-if="visibleEditPass && modeTemplate"
                        slot="append" 
                        @click="editSmtpPassToggle()"
                        :name="disableEditPass ? 'editpencil' : 'cross'"
                        :ariaLabel="disableEditPass ? 'Editar contraseña' : 'Cancelar edición de contraseña'"
                        iconSize="md"
                        size="xs"
                        mode="primary-phantom"
                        class="bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full"
                      />
                    </el-input>
                  </el-form-item>
                </label>
              </div>
            </div>

            <!-- <div class="mb-4">
              <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('smtp.confirmacion_entrega')}}
                <el-switch 
                  class="switch-text break-normal both-switch mt-2" 
                  v-model="form.smptConfirmacionEntrega" 
                  :active-text="$t('companies.active')"/>
              </label>
            </div> -->
          </div>

            </template>
          </base-collapsible-form>

        <div v-if="hasModuleCustomMails">
          <base-collapsible-form 
            ref="baseCollapsibleCustomMailHeaderNEOs" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_header_neos')}}</h2>
            </template>
            <template slot="content">
                
          <base-collapsible-form 
            ref="baseCollapsibleCustomMailNew" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_new')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.asuntoMailNew"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_asunto')}}                  
                      <el-form-item prop="asuntoMailNew">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.asuntoMailNew"
                          maxlength='255'
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.contentTextEditorDefaultNew"
                  />
                  <label class="text-sm font-semibold text-secondary-600 block w-full"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                </div>
                  <TextEditor
                    ref="textEditorCustomMailNew"
                    :contentDefault="contentTextEditorDefaultNew"
                    idDefault="customMailNew"
                    class="mb-4 overflow-visible"
                    :tags="tagsCustomMailNew"
                    :metadatosAdicionales="valuesCamposMetadatos"
                    />
              </div>
          
            </template>
          </base-collapsible-form>
          
          <base-collapsible-form 
            ref="baseCollapsibleCustomMailDownload" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_download')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.asuntoMailDownload"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_asunto')}}
                      <el-form-item prop="asuntoMailDownload">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.asuntoMailDownload"
                          maxlength='255'
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.contentTextEditorDefaultDownload"
                  />
                  <label class="text-sm font-semibold text-secondary-600 block w-full"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                </div>

              <TextEditor
                ref="textEditorCustomMailDownload"
                :contentDefault="contentTextEditorDefaultDownload"
                idDefault="customMailDownload"
                class="mb-4"
                :tags="tagsCustomMailDownload"
                :metadatosAdicionales="valuesCamposMetadatos"
                />
              </div>
          
            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailAviso" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_aviso')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.asuntoMailAviso"
                  />
                  <div class="w-full">
                  <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_asunto')}}
                    <el-form-item prop="asuntoMailAviso">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.asuntoMailAviso"
                        maxlength='255'
                      />
                    </el-form-item>
                  </label>
                  </div>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.contentTextEditorDefaultAviso"
                  />
                  <label class="text-sm font-semibold text-secondary-600 block w-full"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                </div>
              <TextEditor
                ref="textEditorCustomMailAviso"
                :contentDefault="contentTextEditorDefaultAviso"
                idDefault="customMailAviso"
                class="mb-4"
                :tags="tagsCustomMailAviso"
                :metadatosAdicionales="valuesCamposMetadatos"
                />
              </div>
            </template>
          </base-collapsible-form>
          
          <base-collapsible-form 
            ref="baseCollapsibleCustomMailTramit" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_tramit')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.asuntoMailTramit"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_asunto')}}
                      <el-form-item prop="asuntoMailTramit">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.asuntoMailTramit"
                          maxlength='255'
                        />
                      </el-form-item>
                    </label>
                </div>
              </div>
              </div>

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.contentTextEditorDefaultTramit"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                </div>
              </div>

              <TextEditor
                ref="textEditorCustomMailTramit"
                :contentDefault="contentTextEditorDefaultTramit"
                idDefault="customMailTramit"
                class="mb-4"
                :tags="tagsCustomMailTramit"
                :metadatosAdicionales="valuesCamposMetadatos"
                />
              </div>
            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailVinc" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_vinc')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.asuntoMailVinc"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_asunto')}}
                      <el-form-item prop="asuntoMailVinc">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.asuntoMailVinc"
                          maxlength='255'
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
              </div>

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.contentTextEditorDefaultVinc"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                </div>
              </div>

              <TextEditor
                ref="textEditorCustomMailVinc"
                :contentDefault="contentTextEditorDefaultVinc"
                idDefault="customMailVinc"
                class="mb-4"
                :tags="tagsCustomMailVinc"
                :metadatosAdicionales="valuesCamposMetadatos"
                />
              </div>
            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailVincEnlace" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_vinc_enlace')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.asuntoMailVincEnlace"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_asunto')}}
                      <el-form-item prop="asuntoMailVincEnlace">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.asuntoMailVincEnlace"
                          maxlength='255'
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
              </div>

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.contentTextEditorDefaultVincEnlace"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                </div>
              </div>

              <TextEditor
                ref="textEditorCustomMailVincEnlace"
                :contentDefault="contentTextEditorDefaultVincEnlace"
                idDefault="customMailVincEnlace"
                class="mb-4"
                :tags="tagsCustomMailVincEnlace"
                :metadatosAdicionales="valuesCamposMetadatos"
                />
              </div>
            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailManual" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_manual')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.asuntoMailManual"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_asunto')}}
                      <el-form-item prop="asuntoMailManual">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.asuntoMailManual"
                          maxlength='255'
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
              </div>

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.contentTextEditorDefaultManual"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                </div>
              </div>

              <TextEditor
                ref="textEditorCustomMailManual"
                :contentDefault="contentTextEditorDefaultManual"
                idDefault="customMailManual"
                class="mb-4"
                :tags="tagsCustomMailManual"
                :metadatosAdicionales="valuesCamposMetadatos"
                />
              </div>
            </template>
          </base-collapsible-form>

          </template>
        </base-collapsible-form>
          <base-collapsible-form 
            ref="baseCollapsibleCustomMailHeaderLicenciamiento" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_header_licenciamiento')}}</h2>
            </template>
            <template slot="content">

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailNeos" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_neos')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.asuntoMailNeos"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_asunto')}}
                      <el-form-item prop="asuntoMailNeos">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.asuntoMailNeos"
                          maxlength='255'
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
              </div>

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.contentTextEditorDefaultNeos"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                </div>
              </div>

              <TextEditor
                ref="textEditorCustomMailNeos"
                :contentDefault="contentTextEditorDefaultNeos"
                idDefault="customMailNeos"
                class="mb-4"
                :tags="tagsCustomMailNeos"
                :metadatosAdicionales="valuesCamposMetadatos"
                />
              </div>
            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailEspacio" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_espacio')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.asuntoMailEspacio"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_asunto')}}
                      <el-form-item prop="asuntoMailEspacio">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.asuntoMailEspacio"
                          maxlength='255'
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
              </div>

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.contentTextEditorDefaultEspacio"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                </div>
              </div>

              <TextEditor
                ref="textEditorCustomMailEspacio"
                :contentDefault="contentTextEditorDefaultEspacio"
                idDefault="customMailEspacio"
                class="mb-4"
                :tags="tagsCustomMailEspacio"
                :metadatosAdicionales="valuesCamposMetadatos"
                />
              </div>
            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailSMS" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_sms')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.asuntoMailSMS"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_asunto')}}
                      <el-form-item prop="asuntoMailSMS">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.asuntoMailSMS"
                          maxlength='255'
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
              </div>

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.contentTextEditorDefaultSMS"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                </div>
              </div>

              <TextEditor
                ref="textEditorCustomMailSMS"
                :contentDefault="contentTextEditorDefaultSMS"
                idDefault="customMailSMS"
                class="mb-4"
                :tags="tagsCustomMailSMS"
                :metadatosAdicionales="valuesCamposMetadatos"
                />
              </div>
            </template>
          </base-collapsible-form>
          </template>
        </base-collapsible-form>
          <base-collapsible-form 
            ref="baseCollapsibleCustomMailHeaderUsers" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_header_users')}}</h2>
            </template>
            <template slot="content">

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailNuevoUsuario" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_nuevo_usuario')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.asuntoMailNuevoUsuario"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_asunto')}}
                      <el-form-item prop="asuntoMailNuevoUsuario">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.asuntoMailNuevoUsuario"
                          maxlength='255'
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
              </div>

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.contentTextEditorDefaultNuevoUsuario"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                </div>
              </div>

              <TextEditor
                ref="textEditorCustomMailNuevoUsuario"
                :contentDefault="contentTextEditorDefaultNuevoUsuario"
                idDefault="customMailNuevoUsuario"
                class="mb-4"
                :tags="tagsCustomMailNuevoUsuario"
                :metadatosAdicionales="valuesCamposMetadatos"
                />
              </div>
            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailRecuperacionPass" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_recuperacion_pass')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.asuntoMailRecuperacionPass"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_asunto')}}
                      <el-form-item prop="asuntoMailRecuperacionPass">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.asuntoMailRecuperacionPass"
                          maxlength='255'
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
              </div>

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.contentTextEditorDefaultRecuperacionPass"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                </div>
              </div>

              <TextEditor
                ref="textEditorCustomMailRecuperacionPass"
                :contentDefault="contentTextEditorDefaultRecuperacionPass"
                idDefault="customMailRecuperacionPass"
                class="mb-4"
                :tags="tagsCustomMailRecuperacionPass"
                :metadatosAdicionales="valuesCamposMetadatos"
                />
              </div>
            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailDobleAuth" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_doble_auth')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.asuntoMailDobleAuth"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_asunto')}}
                      <el-form-item prop="asuntoMailDobleAuth">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.asuntoMailDobleAuth"
                          maxlength='255'
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
              </div>

              <div class="lg:mb-2">
                
                <div class="flex items-center px-2 w-full mb-1">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg '
                    type='checkbox'
                    v-model="valuesCheckbox.contentTextEditorDefaultDobleAuth"
                  />
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                </div>
              </div>

              <TextEditor
                ref="textEditorCustomMailDobleAuth"
                :contentDefault="contentTextEditorDefaultDobleAuth"
                idDefault="customMailDobleAuth"
                class="mb-4"
                :tags="tagsCustomMailDobleAuth"
                :metadatosAdicionales="valuesCamposMetadatos"
                />
              </div>
            </template>
          </base-collapsible-form>
          </template>
        </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailOtrosAvisos" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_header_otros_avisos')}}</h2>
            </template>
            <template slot="content">

              <base-collapsible-form
                v-if="form.asuntoMailFinWizard"
                ref="baseCollapsibleCustomMailFinWizard" 
                class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_fin_wizard')}}</h3>
                </template>
                <template slot="content">

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="false"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.asuntoMailFinWizard"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_asunto')}}
                          <el-form-item prop="asuntoMailFinWizard">
                            <el-input
                              clearable
                              class="w-full"
                              v-model="form.asuntoMailFinWizard"
                              maxlength='255'
                            />
                          </el-form-item>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="false"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.contentTextEditorDefaultFinWizard"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                    </div>
                  </div>

                  <TextEditor
                    ref="textEditorCustomMailFinWizard"
                    :contentDefault="contentTextEditorDefaultFinWizard"
                    idDefault="customMailFinWizard"
                    class="mb-4"
                    :tags="tagsCustomMailFinWizard"
                    :metadatosAdicionales="valuesCamposMetadatos"
                    />
                  </div>

                </template>
              </base-collapsible-form>

              <base-collapsible-form 
                ref="baseCollapsibleCustomMailOtrosAvisos" 
                class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_otros_avisos')}}</h3>
                </template>
                <template slot="content">

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.asuntoMailOtrosAvisos"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_asunto')}}
                          <el-form-item prop="asuntoMailOtrosAvisos">
                            <el-input
                              clearable
                              class="w-full"
                              v-model="form.asuntoMailOtrosAvisos"
                              maxlength='255'
                            />
                          </el-form-item>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.contentTextEditorDefaultOtrosAvisos"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                    </div>
                  </div>

                  <TextEditor
                    ref="textEditorCustomMailOtrosAvisos"
                    :contentDefault="contentTextEditorDefaultOtrosAvisos"
                    idDefault="customMailOtrosAvisos"
                    class="mb-4"
                    :tags="tagsCustomMailOtrosAvisos"
                    :metadatosAdicionales="valuesCamposMetadatos"
                    />
                  </div>

                </template>
              </base-collapsible-form>

            </template>
          </base-collapsible-form>

        </div>
        </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="isFromClient ? $t('app.cancel') : $t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive v-if="enableEditCampos" mode="primary" :forceIcon="true" :text="!modeTemplate ? $t('configurations.change_mode_template') : $t('configurations.change_mode_template_edit')" @click="toggleModeTemplate()"  icon="refresh" :loading="isGeneralLoading"/>
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('configurations.link_template_to_clients')" @click="toggleDialogLink"  icon="link" :loading="isGeneralLoading"/>
          <base-button-responsive 
            v-if="!modeTemplate" 
            mode="primary" 
            :text="$t('configurations.apply_to_clients')" 
            @click="toggleDialogLink"  
            icon="link" 
            :loading="isGeneralLoading"
            v-popover:popover
          />
          <base-button-responsive 
            mode="primary" 
            v-if="
              modeTemplate && 
             (hasModuleCustomSMTPCliente || (hasModuleCustomSMTPZerocoma && role === 'SuperAdministrador')) &&
             showTestHotFolder && 
             form.smtpMain" 
            :text="$t('app.test_btn_smtp')" 
            icon="mailtest" 
            @click="submitForm('ruleForm', true)" 
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading"
          />
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('app.save')" icon="save" @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
          <el-popover
            ref="popover"
            placement="top"
            width="250"
            v-model="showPopoverRedirection"
            popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
            trigger="manual"
            >
            <p>Se han preseleccionado</p>
            <p>los clientes seleccionados. </p>
          </el-popover>
        </template>
      </base-footer>
      <input-text-mail-dialog 
        :dialogOpen="showModalHotFolder" 
        @toggleDialog="toggleModalHotFolder" 
        @applyDialog="testHotFolder"
        header="Enviar email de prueba" 
        headerValue="Destinatario" 
        />
      <template-link-clients-dialog 
        ref="templatelinkcompaniesdialog" 
        :title="titleLinkClients" 
        :distributorId="this.id" 
        :dialogOpen="linkToClientsDialog" 
        @toggleDialog="toggleDialogLink" 
        @applyDialog="applyLinkHandler" />
    </template>
  </detail-layout-full-width>
</template>

<script>
import { bus } from '@/main'
import { getLogoCustomTemplate } from '@/services/clients/getLogoCustomTemplate'
import { getConfigSMTPTemplate } from '@/services/clients/getConfigSMTPTemplate'
import { getConfigCorreosTemplate } from '@/services/clients/getConfigCorreosTemplate'
import { getConfigCorreosTags } from '@/services/clients/getConfigCorreosTags'
import { getColorsCustomTemplate } from '@/services/clients/getColorsCustomTemplate'

import { updateClientPersonalizacionTemplate } from '@/services/clients/updateClientPersonalizacionTemplate'
import { applyClientPersonalizationTemplate } from '@/services/clients/applyClientPersonalizationTemplate'
import { applyClientPersonalizationKeys } from '@/services/clients/applyClientPersonalizationKeys'
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import TemplateLinkClientsDialog from '@/components/TemplateLinkClientsDialog.vue'

import { i18n } from '@/i18n'
import { COLORES_PREDEFINIDOS } from '@/config/colores-predefinidos'

import { Upload } from 'element-ui'
import TextEditor from '@/components/texteditor/TextEditor.vue'
import { getDistributor } from '@/services/distributors/getDistributor'
import { getCamposMetadatos } from '@/services/notifications/getCamposMetadatos'

import InputTextMailDialog from '@/components/InputTextMailDialog.vue'
import { enviocorreoprueba } from '@/services/clients/enviocorreoprueba' 

import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

function isValidNum (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 999999) {
      return true
    }
  }
  return false
}
export default {
  /* eslint-disable camelcase */
  name: 'template-client-personalization-detail',
  components: {
    DetailLayoutFullWidth,
    TemplateLinkClientsDialog,
    Upload,
    TextEditor,
    InputTextMailDialog,
    Cropper,
  },
  data: function () {
    return {
      isMounted: false,
      modeTemplate: true,
      showPopoverRedirection: false,
      enableEditCampos: true,
      searchView: false,
      linkToClientsDialog: false,
      activeName: 'es',
      tooltipContentLogo: i18n.t('tooltip.logo'),
      header: {
        title: i18n.t('distributors.template_clients_personalization_header'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: this.isFromClient ? 'configurations/distributors/details' : 'configurations/clients'
      },
      showModalHotFolder: false,
      showTestHotFolder: false,

      croppedLight: false,
      croppedDark: false,
      stencilProps: {
        aspectRatio: 300 / 74,
        stencilSize: { width: 300, height: 74 }, 
        stencilResizable: false, 
      },

      colorSelected: null,
      predefineColors: COLORES_PREDEFINIDOS,
      valuesCamposMetadatos: [],

      visibleEditPass: true,
      disableEditPass: true,
        
      form: {
        idClient: null,
        smtpMain: false,
        smtpServer: null,
        smtpFrom: null,
        smtpPort: null,
        smptSSL: true,
        smptOAuth2: null,
        smtpRelay: false,
        smptClientId: null,
        smptTenantId: null,
        smtpUser: null,
        smtpPass: null,
        // smptConfirmacionEntrega: false,
        asuntoMailNew: '',
        asuntoMailDownload: '',
        asuntoMailAviso: '',
        asuntoMailTramit: '',
        asuntoMailVinc: '',
        asuntoMailVincEnlace: '',
        asuntoMailManual: '',

        asuntoMailNuevoUsuario: '',
        asuntoMailRecuperacionPass: '',
        asuntoMailDobleAuth: '',
        asuntoMailOtrosAvisos: '',
        asuntoMailFinWizard: '',
        asuntoMailEspacio: '',
        asuntoMailNeos: '',
        asuntoMailSMS: '',
      },
      // Contenido para cada TextEditor
      contentTextEditorDefaultNew: '',
      contentTextEditorDefaultDownload: '',
      contentTextEditorDefaultAviso: '',
      contentTextEditorDefaultTramit: '',
      contentTextEditorDefaultVinc: '',
      contentTextEditorDefaultVincEnlace: '',
      contentTextEditorDefaultManual: '',

      contentTextEditorDefaultOtrosAvisos: '',
      contentTextEditorDefaultFinWizard: '',
      contentTextEditorDefaultEspacio: '',
      contentTextEditorDefaultNeos: '',
      contentTextEditorDefaultSMS: '',
      contentTextEditorDefaultNuevoUsuario: '',
      contentTextEditorDefaultRecuperacionPass: '',
      contentTextEditorDefaultDobleAuth: '',
      // Etiquetas para cada TextEditor
      tagsCustomMailNew: [],
      tagsCustomMailDownload: [],
      tagsCustomMailAviso: [],
      tagsCustomMailTramit: [],
      tagsCustomMailVinc: [],
      tagsCustomMailVincEnlace: [],
      tagsCustomMailManual: [],
      tagsCustomMailNuevoUsuario: [],
      tagsCustomMailRecuperacionPass: [],
      tagsCustomMailDobleAuth: [],
      tagsCustomMailOtrosAvisos: [],
      tagsCustomMailFinWizard: [],
      tagsCustomMailEspacio: [],
      tagsCustomMailNeos: [],
      tagsCustomMailSMS: [],

      maxSizefile: 1048576, // Bytes (1MB)
      fileLight: {
        name: '',
        b64: '',
        bytes: null,
      },
      fileDark: {
        name: '',
        b64: '',
        bytes: null,
      },
      checkall: false,
      valuesCheckbox: {
        fileLight: false,
        fileDark: false,

        color: false,

        Smtp: false,
        // smptConfirmacionEntrega: false,

        asuntoMailNew: false,
        asuntoMailDownload: false,
        asuntoMailAviso: false,
        asuntoMailTramit: false,
        asuntoMailVinc: false,
        asuntoMailVincEnlace: false,
        asuntoMailManual: false,
        asuntoMailNuevoUsuario: false,
        asuntoMailRecuperacionPass: false,
        asuntoMailDobleAuth: false,
        asuntoMailOtrosAvisos: false,
        asuntoMailFinWizard: false,
        asuntoMailEspacio: false,
        asuntoMailNeos: false,
        asuntoMailSMS: false,

        contentTextEditorDefaultNew: false,
        contentTextEditorDefaultDownload: false,
        contentTextEditorDefaultAviso: false,
        contentTextEditorDefaultTramit: false,
        contentTextEditorDefaultVinc: false,
        contentTextEditorDefaultVincEnlace: false,
        contentTextEditorDefaultManual: false,
        contentTextEditorDefaultOtrosAvisos: false,
        contentTextEditorDefaultFinWizard: false,
        contentTextEditorDefaultEspacio: false,
        contentTextEditorDefaultNeos: false,
        contentTextEditorDefaultSMS: false,
        contentTextEditorDefaultNuevoUsuario: false,
        contentTextEditorDefaultRecuperacionPass: false,
        contentTextEditorDefaultDobleAuth: false,
      },
      rules: {
        fileLight: [
          {
            message: this.$i18n.t('validation.not_logo_custom'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileLight.name && 
                (this.fileLight.name.length < 5 || 
                (!this.isValidExtension(this.fileLight.name)))
              ) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.not_logo_custom'), callback)
              } else {
                callback()
              }
            }
          },
          {
            message: this.$i18n.t('validation.logo_recortar'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileLight.name &&
                this.croppedLight === false
              ) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.logo_recortar'), callback)
              } else {
                callback()
              }
            }
          },
        ],
        fileDark: [
          {
            message: this.$i18n.t('validation.not_logo_custom'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileDark.name && 
                (this.fileDark.name.length < 5 || 
                (!this.isValidExtension(this.fileDark.name)))
              ) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.not_logo_custom'), callback)
              } else {
                callback()
              }
            }
          },
          {
            message: this.$i18n.t('validation.logo_recortar'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileDark.name &&
                this.croppedDark === false
              ) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.logo_recortar'), callback)
              } else {
                callback()
              }
            }
          },
        ],
        smtpServer: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        smtpFrom: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        smtpPort: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        smptClientId: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        smptTenantId: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        smtpUser: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        smtpPass: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
      }
    }
  },
  computed: {
    validLightImage () {
      if (!this.fileLight) return false
      return this.fileLight.b64 && this.isValidExtension(this.fileLight.name)
    },
    validDarkImage () {
      if (!this.fileDark) return false
      return this.fileDark.b64 && this.isValidExtension(this.fileDark.name)
    },
    srcImageLight () {
      if (!this.$refs.baseCollapsibleLogo?.isActive) return null
      if (!this.fileLight || !this.fileLight.b64) return null
      return 'data:image/png;base64, ' + this.fileLight?.b64
    },
    srcImageDark () {
      if (!this.$refs.baseCollapsibleLogo?.isActive) return null
      if (!this.fileDark || !this.fileDark.b64) return null
      return 'data:image/png;base64, ' + this.fileDark?.b64
    },
    gettextEditorCustomMailNew () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailNew.getContent()
    },
    gettextEditorCustomMailDownload () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailDownload.getContent()
    },
    gettextEditorCustomMailAviso () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailAviso.getContent()
    },
    gettextEditorCustomMailTramit () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailTramit.getContent()
    },
    gettextEditorCustomMailVinc () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailVinc.getContent()
    },
    gettextEditorCustomMailVincEnlace () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailVincEnlace.getContent()
    },
    gettextEditorCustomMailManual () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailManual.getContent()
    },
    gettextEditorCustomMailNuevoUsuario () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailNuevoUsuario.getContent()
    },
    gettextEditorCustomMailRecuperacionPass () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailRecuperacionPass.getContent()
    },
    gettextEditorCustomMailDobleAuth () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailDobleAuth.getContent()
    },
    gettextEditorCustomMailOtrosAvisos () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailOtrosAvisos.getContent()
    },
    gettextEditorCustomMailFinWizard () { 
      if (!this.isMounted || !this.form?.asuntoMailFinWizard) return
      return this.$refs.textEditorCustomMailFinWizard.getContent()
    },
    gettextEditorCustomMailEspacio () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailEspacio.getContent()
    },
    gettextEditorCustomMailNeos () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailNeos.getContent()
    },
    gettextEditorCustomMailSMS () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailSMS.getContent()
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    titleLinkClients () {
      return this.modeTemplate ? 'Aplicar plantilla a clientes' : 'Aplicar campos seleccionados a clientes'
    },
    id () {
      return this.$route.params.id ? parseInt(this.$route.params.id) : -1
    },
    isFromClient () {
      return this.id !== -1
    },
    hasModuleCustomSMTPCliente () {
      return this.$store.getters['auth/hasModuleCustomSMTPCliente']
    },
    hasModuleCustomSMTPZerocoma () {
      return this.$store.getters['auth/hasModuleCustomSMTPZerocoma'] && this.role === 'SuperAdministrador'
    },
    hasModuleCustomLogo () {
      return this.$store.getters['auth/hasModuleCustomLogo']
    },
    hasModuleCustomColors () {
      return this.$store.getters['auth/hasModuleCustomColors']
    },
    hasModuleCustomMails () {
      return this.$store.getters['auth/hasModuleCustomMails']
    },
    hasLogoLightSaved () {
      return this.fileLight && this.fileLight.b64 
    },
    hasLogoDarkSaved () {
      return this.fileDark && this.fileDark.b64 
    },
    isPasswordSmtpVisible () {
      return this.form.smtpMain && (this.hasModuleCustomSMTPCliente || this.hasModuleCustomSMTPZerocoma) && (!this.form.smtpRelay)
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    colorSelected: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    fileLight: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    fileDark: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    valuesCheckbox: {
      deep: true,
      immediate: true,
      handler: 'watchValuesCheckboxHandler'
    },
    gettextEditorCustomMailNew: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailDownload: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailAviso: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailTramit: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailVinc: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailVincEnlace: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailManual: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailNuevoUsuario: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailRecuperacionPass: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailDobleAuth: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailOtrosAvisos: { 
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailFinWizard: { 
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailEspacio: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailNeos: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailSMS: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    modeTemplate: function (value, oldValue) {
      if (!value) this.header.title = this.$i18n.t('configurations.template_header_text_mode')
      else this.header.title = this.$i18n.t('configurations.template_header_text')
    },
    isPasswordSmtpVisible: function (value, oldValue) {
      if (value) this.fixAccesibilityElInputPass()
    },
  },
  created: async function () {
    const breadcrumbs = []
    if (this.isFromClient) {
      breadcrumbs.push({
        path: 'configurationssa',
        name: this.$i18n.t('app.configurations')
      })
      breadcrumbs.push({
        path: 'configurations/distributors',
        name: this.$i18n.t('distributors.header')
      })
      const distributor = await this.downloadDistributorData(this.id)
      breadcrumbs.push({ path: '', name: distributor.distribuidor.Nombre })
      this.$store.commit('app/setheaderBreadCrumb', distributor.distribuidor.Nombre)
      this.disableRoutes(distributor.distribuidor.idTipoProvisionamiento)
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted: async function () {
    this.isMounted = true
    if (this.$route.params.data) {
      this.preSelectClients()
    } else {
      this.$store.commit('setIsLoading', true)
      const dataColors = await this.downloadDataColors(this.id)
      this.setDataColors(dataColors)
      const dataSmtp = await this.downloadDataSmtp(this.id)
      this.setDataSmtp(dataSmtp.ConfigSMTP)
      const dataCorreos = await this.downloadDataCorreos(this.id)
      this.setDataCorreos(dataCorreos.Plantillas)
      const dataCorreosTags = await this.downloadDataCorreosTags(this.id)
      this.setDataCorreosTags(dataCorreosTags.Tags)
      const dataLogo = await this.downloadDataLogo(this.id)
      this.setDataLogo(dataLogo)
      this.$store.commit('setIsLoading', false)
    }
    this.resetControlFormChanges()
    
    // Carga de campos de metadatos
    const metadatos = await getCamposMetadatos()
    if (metadatos.blnError) {
      this.doFeedback(metadatos.msgError + ' [Código de error: ' + metadatos.codError + ']')
    } else {
      const self = this
      metadatos.Respuesta.forEach(function (value, i) {
        const metadato = { Nombre: value, id: i }
        self.valuesCamposMetadatos.push(metadato)
      })
    }
    this.fixAccesibilityElInputPass()
  },
  methods: {
    isValidExtension (fileName) {
      if (!fileName || fileName.length < 5) return false
      const extension = this.getExtensionFromFile(fileName).toUpperCase()
      return extension === 'PNG' || extension === 'WEBP' ||
        extension === 'JPG' || extension === 'JPEG'
    },
    recortarModoClaro: async function () {
      const b64 = await this.cropImage('cropperLight')
      this.fileLight.b64 = b64
      this.croppedLight = true
    },
    recortarModoOscuro: async function () {
      const b64 = await this.cropImage('cropperDark')
      this.fileDark.b64 = b64
      this.croppedDark = true
    },
    cropImage: async function (refName) {
      if (!this.$refs[refName]) return

      const result = this.$refs[refName].getResult(/* {width: 300, height: 74, } */)
      
      const targetWidth = 300
      const targetHeight = 74
      const resizedCanvas = document.createElement('canvas')
      resizedCanvas.width = targetWidth
      resizedCanvas.height = targetHeight

      const ctx = resizedCanvas.getContext('2d')
      ctx.drawImage(result.canvas, 0, 0, targetWidth, targetHeight)

      // Retornamos una promesa que resuelve con el base64
      return new Promise(resolve => {
        resizedCanvas.toBlob(async blob => {
          const b64 = await this.blobToBase64(blob)
          resolve(b64)
        }, 'image/png')
      })
    },
    blobToBase64 (blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result.split(',')[1]) // quita el encabezado data:
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },
    fixAccesibilityElInputPass () {
      this.$nextTick(() => {
      // Timeout para esperar a que se rendericen los iconos
        setTimeout(() => {
          this.fixAccesibilityElInputPassword(this.$refs.passwordInputPassPersonalizationTemplate, this.$i18n.t('aria.elementui.input.password'))
        }, 1000)
      })
    },
    toggleModalHotFolder () {
      this.showModalHotFolder = !this.showModalHotFolder
    },
    editSmtpPassToggle () {
      if (this.disableEditPass) this.form.smtpPass = ''
      else this.form.smtpPass = '**********'
      this.disableEditPass = !this.disableEditPass
    },
    toggleShowHidePass (disable = true) {
      this.form.smtpPass = disable ? '**********' : ''
      this.disableEditPass = disable
      this.visibleEditPass = disable
    },
    disableRoutes: function (idTipoProvisionamiento) {
      const objDisableRoutes = {
        disableModules: idTipoProvisionamiento === 1,
        disableLocations: idTipoProvisionamiento === 1,
      }
      bus.$emit('disableOptionsDistributor', objDisableRoutes)
    },
    handleChangeLight: function (fileLight) {
      this.croppedLight = false
      this.$refs.uploadlogo.clearValidate()
      this.fileLight.name = fileLight.name
      this.getBase64(fileLight.raw).then(res => {
        const b64 = res.split(',')
        this.fileLight.b64 = b64[1]
      })
      this.fileLight.bytes = fileLight
    },
    handleChangeDark: function (fileDark) {
      this.croppedDark = false
      this.$refs.uploadlogo.clearValidate()
      this.fileDark.name = fileDark.name
      this.getBase64(fileDark.raw).then(res => {
        const b64 = res.split(',')
        this.fileDark.b64 = b64[1]
      })
      this.fileDark.bytes = fileDark
    },
    handleRemoveLight: function () {
      this.fileLight.name = null
      this.fileLight.b64 = null
      this.fileLight.bytes = null
    },
    handleRemoveDark: function () {
      this.fileDark.name = null
      this.fileDark.b64 = null
      this.fileDark.bytes = null
    },
    testHotFolder: async function (destinatario) {
      try {
        this.$store.commit('setIsLoading', true)
        const res = await enviocorreoprueba({ 
          idDistribuidor: this.id,
          destinatario: destinatario,
        })
        if (res.blnError) {
          this.doFeedback(res.msgError + ' [Código de error: ' + res.codError + ']')
        } else {
          this.toggleModalHotFolder()
          this.doFeedback('Prueba realizada correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    isNumberValid: function (rule, value, callback) {
      if (!value || value === '') {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
        // callback()
      } else if (!isValidNum(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.template.num_license'), callback)
      } else {
        callback()
      }
    },
    preSelectClients () {
      this.enableEditCampos = false
      this.modeTemplate = false
      this.visibleEditPass = false
      this.disableEditPass = false
      const data = this.$route.params.data
      if (data && data.clients) {
        this.$refs.templatelinkcompaniesdialog.changeSelectedCompanies(data.clients)
      }
      this.togglePopoverRedirection()
    },
    togglePopoverRedirection: async function () {
      this.showPopoverRedirection = true
      setTimeout(() => {
        this.showPopoverRedirection = false
      }, 3000)
    },
    watchValuesCheckboxHandler: function () {
      const aux = this.valuesCheckbox
      const checkboxKeys = Object.keys(aux)
      this.checkall = true
      checkboxKeys.forEach(key => {
        if (!aux[key]) {
          this.checkall = false
          return false
        }
      })
    },
    toggleModeTemplate: function () {
      this.modeTemplate = !this.modeTemplate
      if (!this.modeTemplate) {
        this.disableEditPass = false
        this.form.smtpPass = ''
      }
    },
    changeAllCheckbox (value) {
      this.valuesCheckbox.fileLight = value
      this.valuesCheckbox.fileDark = value
      this.valuesCheckbox.color = value
      this.valuesCheckbox.Smtp = value
      this.valuesCheckbox.asuntoMailNew = value
      this.valuesCheckbox.asuntoMailDownload = value
      this.valuesCheckbox.asuntoMailAviso = value
      this.valuesCheckbox.asuntoMailTramit = value
      this.valuesCheckbox.asuntoMailVinc = value
      this.valuesCheckbox.asuntoMailVincEnlace = value
      this.valuesCheckbox.asuntoMailManual = value
      this.valuesCheckbox.asuntoMailNuevoUsuario = value
      this.valuesCheckbox.asuntoMailRecuperacionPass = value
      this.valuesCheckbox.asuntoMailDobleAuth = value
      this.valuesCheckbox.asuntoMailOtrosAvisos = value
      // this.valuesCheckbox.asuntoMailFinWizard = value
      this.valuesCheckbox.asuntoMailEspacio = value
      this.valuesCheckbox.asuntoMailNeos = value
      this.valuesCheckbox.asuntoMailSMS = value
      this.valuesCheckbox.contentTextEditorDefaultNew = value
      this.valuesCheckbox.contentTextEditorDefaultDownload = value
      this.valuesCheckbox.contentTextEditorDefaultAviso = value
      this.valuesCheckbox.contentTextEditorDefaultTramit = value
      this.valuesCheckbox.contentTextEditorDefaultVinc = value
      this.valuesCheckbox.contentTextEditorDefaultVincEnlace = value
      this.valuesCheckbox.contentTextEditorDefaultManual = value
      this.valuesCheckbox.contentTextEditorDefaultOtrosAvisos = value
      // this.valuesCheckbox.contentTextEditorDefaultFinWizard = value 
      this.valuesCheckbox.contentTextEditorDefaultNeos = value
      this.valuesCheckbox.contentTextEditorDefaultSMS = value
      this.valuesCheckbox.contentTextEditorDefaultNuevoUsuario = value
      this.valuesCheckbox.contentTextEditorDefaultRecuperacionPass = value
      this.valuesCheckbox.contentTextEditorDefaultDobleAuth = value
    },
    toggleDialogLink: function () {
      this.linkToClientsDialog = !this.linkToClientsDialog
    },
    applyLinkHandler: async function (clients) {
      if (this.modeTemplate) {
        this.submitFormAndUpdateClients('ruleForm', clients)
      } else {
        this.UpdateClientsWithSelected('ruleForm', clients)
      }
    },
    downloadDistributorData: async function (id) {
      let distributor = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idDistribuidor: id
        }
        distributor = await getDistributor(params)
        if (distributor.blnError === true) {
          this.doFeedback(distributor.msgError + ' [Código de error: ' + distributor.codError + ']')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return distributor
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName, test = false) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const payload = {
            idDistribuidor: this.id,
            Logo: this.hasModuleCustomLogo && this.fileLight && this.fileLight.b64 && this.fileLight.name
              ? {
                Contenido: this.fileLight.b64,
                Extension: this.getExtensionFromFile(this.fileLight.name)
              } 
              : null,
            LogoDark: this.hasModuleCustomLogo && this.fileDark && this.fileDark.b64 && this.fileDark.name
              ? {
                Contenido: this.fileDark.b64,
                Extension: this.getExtensionFromFile(this.fileDark.name)
              }
              : null,
            Color: this.hasModuleCustomColors ? this.colorSelected : null,
            ConfigSMTP: (this.hasModuleCustomSMTPCliente || this.hasModuleCustomSMTPZerocoma)
              ? {
                Activo: this.form.smtpMain,
                Servidor: this.form.smtpServer,
                UsrDefecto: this.form.smtpFrom,
                Puerto: this.form.smtpPort,
                SSL: this.form.smptSSL,
                OAuth2: this.form.smptOAuth2,
                Relay: this.form.smtpRelay,
                ClientId: this.form.smptOAuth2 ? this.form.smptClientId : null,
                TenantId: this.form.smptOAuth2 ? this.form.smptTenantId : null,
                Usuario: this.form.smtpUser,
                Password: this.disableEditPass ? null : this.form.smtpPass,
              }
              : null,
            PlantillasCorreos: this.hasModuleCustomMails 
              ? {
                AsuntoAvisoNuevaNotificacion: this.form.asuntoMailNew,
                AsuntoAvisoDescargaNotificacion: this.form.asuntoMailDownload,
                AsuntoAvisoNotificacionesDiarias: this.form.asuntoMailAviso,
                AsuntoAvisoNotificacionTramitada: this.form.asuntoMailTramit,
                AsuntoAvisoNotificacionVinculada: this.form.asuntoMailVinc,
                AsuntoAvisoNotificacionVinculadaEnlace: this.form.asuntoMailVincEnlace,
                AsuntoAvisoNotificacionEnvioManual: this.form.asuntoMailManual,
                AsuntoUsuarioNuevo: this.form.asuntoMailNuevoUsuario,
                AsuntoRecuperacionPassword: this.form.asuntoMailRecuperacionPass,
                AsuntoDobleAuth: this.form.asuntoMailDobleAuth,
                AsuntoAvisoOtros: this.form.asuntoMailOtrosAvisos,
                AsuntoFinWizard: this.form.asuntoMailFinWizard,
                AsuntoAvisoEspacioSuperado: this.form.asuntoMailEspacio,
                AsuntoAvisoNotificacionesSuperadas: this.form.asuntoMailNeos,
                AsuntoAvisoSMSSuperado: this.form.asuntoMailSMS,
                CuerpoAvisoNuevaNotificacion: this.$refs.textEditorCustomMailNew.getContent(),
                CuerpoAvisoDescargaNotificacion: this.$refs.textEditorCustomMailDownload.getContent(),
                CuerpoAvisoNotificacionesDiarias: this.$refs.textEditorCustomMailAviso.getContent(),
                CuerpoAvisoNotificacionTramitada: this.$refs.textEditorCustomMailTramit.getContent(),
                CuerpoAvisoNotificacionVinculada: this.$refs.textEditorCustomMailVinc.getContent(),
                CuerpoAvisoNotificacionVinculadaEnlace: this.$refs.textEditorCustomMailVincEnlace.getContent(),
                CuerpoAvisoNotificacionEnvioManual: this.$refs.textEditorCustomMailManual.getContent(),
                CuerpoUsuarioNuevo: this.$refs.textEditorCustomMailNuevoUsuario.getContent(),
                CuerpoRecuperacionPassword: this.$refs.textEditorCustomMailRecuperacionPass.getContent(),
                CuerpoDobleAuth: this.$refs.textEditorCustomMailDobleAuth.getContent(),
                CuerpoAvisoOtros: this.$refs.textEditorCustomMailOtrosAvisos.getContent(),
                CuerpoFinWizard: this.form.asuntoMailFinWizard ? this.$refs.textEditorCustomMailFinWizard.getContent() : null,
                CuerpoAvisoEspacioSuperado: this.$refs.textEditorCustomMailEspacio.getContent(),
                CuerpoAvisoNotificacionesSuperadas: this.$refs.textEditorCustomMailNeos.getContent(),
                CuerpoAvisoSMSSuperado: this.$refs.textEditorCustomMailSMS.getContent(),
              } 
              : null,
          }
          const response = await updateClientPersonalizacionTemplate({ idDistribuidor: this.id }, payload)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.showTestHotFolder = true
            this.doFeedback('Plantilla guardada correctamente', 'success')
            if ((this.hasModuleCustomSMTPCliente || this.hasModuleCustomSMTPZerocoma) && this.form.smtpMain) {
              this.toggleShowHidePass(!this.form.smtpRelay)
            }
            if (this.hasModuleCustomLogo && this.fileLight && this.fileLight.b64 && this.fileLight.name) {
              this.fileLight.b64 = payload.Logo.Contenido
            }
            if (this.hasModuleCustomLogo && this.fileDark && this.fileDark.b64 && this.fileDark.name) {
              this.fileDark.b64 = payload.LogoDark.Contenido
            }
            await this.$store.dispatch('app/getColors')
            await this.$store.dispatch('app/updateFrontColors')
            this.resetControlFormChanges()
            if (test) {
              this.toggleModalHotFolder()
            }
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    submitFormAndUpdateClients: function (formName, clients) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const payload = {
            idDistribuidor: this.id,
            Logo: this.hasModuleCustomLogo && this.fileLight && this.fileLight.b64 && this.fileLight.name
              ? {
                Contenido: this.fileLight.b64,
                Extension: this.getExtensionFromFile(this.fileLight.name)
              } 
              : null,
            LogoDark: this.hasModuleCustomLogo && this.fileDark && this.fileDark.b64 && this.fileDark.name
              ? {
                Contenido: this.fileDark.b64,
                Extension: this.getExtensionFromFile(this.fileDark.name)
              }
              : null,
            Color: this.hasModuleCustomColors ? this.colorSelected : null,
            ConfigSMTP: (this.hasModuleCustomSMTPCliente || this.hasModuleCustomSMTPZerocoma)
              ? {
                Activo: this.form.smtpMain,
                Servidor: this.form.smtpServer,
                UsrDefecto: this.form.smtpFrom,
                Puerto: this.form.smtpPort,
                SSL: this.form.smptSSL,
                OAuth2: this.form.smptOAuth2,
                Relay: this.form.smtpRelay,
                ClientId: this.form.smptClientId,
                TenantId: this.form.smptTenantId,
                Usuario: this.form.smtpUser,
                Password: this.disableEditPass ? null : this.form.smtpPass,
              }
              : null,
            PlantillasCorreos: this.hasModuleCustomMails 
              ? {
                AsuntoAvisoNuevaNotificacion: this.form.asuntoMailNew,
                AsuntoAvisoDescargaNotificacion: this.form.asuntoMailDownload,
                AsuntoAvisoNotificacionesDiarias: this.form.asuntoMailAviso,
                AsuntoAvisoNotificacionTramitada: this.form.asuntoMailTramit,
                AsuntoAvisoNotificacionVinculada: this.form.asuntoMailVinc,
                AsuntoAvisoNotificacionVinculadaEnlace: this.form.asuntoMailVincEnlace,
                AsuntoAvisoNotificacionEnvioManual: this.form.asuntoMailManual,
                AsuntoUsuarioNuevo: this.form.asuntoMailNuevoUsuario,
                AsuntoRecuperacionPassword: this.form.asuntoMailRecuperacionPass,
                AsuntoDobleAuth: this.form.asuntoMailDobleAuth,
                AsuntoAvisoOtros: this.form.asuntoMailOtrosAvisos,
                AsuntoFinWizard: this.form.asuntoMailFinWizard,
                AsuntoAvisoEspacioSuperado: this.form.asuntoMailEspacio,
                AsuntoAvisoNotificacionesSuperadas: this.form.asuntoMailNeos,
                AsuntoAvisoSMSSuperado: this.form.asuntoMailSMS,
                CuerpoAvisoNuevaNotificacion: this.gettextEditorCustomMailNew,
                CuerpoAvisoDescargaNotificacion: this.gettextEditorCustomMailDownload,
                CuerpoAvisoNotificacionesDiarias: this.gettextEditorCustomMailAviso,
                CuerpoAvisoNotificacionTramitada: this.gettextEditorCustomMailTramit,
                CuerpoAvisoNotificacionVinculada: this.gettextEditorCustomMailVinc,
                CuerpoAvisoNotificacionVinculadaEnlace: this.gettextEditorCustomMailVincEnlace,
                CuerpoAvisoNotificacionEnvioManual: this.gettextEditorCustomMailManual,
                CuerpoUsuarioNuevo: this.gettextEditorCustomMailNuevoUsuario,
                CuerpoRecuperacionPassword: this.gettextEditorCustomMailRecuperacionPass,
                CuerpoDobleAuth: this.gettextEditorCustomMailDobleAuth,
                CuerpoAvisoOtros: this.gettextEditorCustomMailOtrosAvisos,
                CuerpoFinWizard: this.gettextEditorCustomMailFinWizard,
                CuerpoAvisoEspacioSuperado: this.gettextEditorCustomMailEspacio,
                CuerpoAvisoNotificacionesSuperadas: this.gettextEditorCustomMailNeos,
                CuerpoAvisoSMSSuperado: this.gettextEditorCustomMailSMS,
              } 
              : null,
          }
          this.toggleDialogLink()
          const response = await updateClientPersonalizacionTemplate({ idDistribuidor: this.id }, payload)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Plantilla guardada correctamente', 'success')
            if ((this.hasModuleCustomSMTPCliente || this.hasModuleCustomSMTPZerocoma) && this.form.smtpMain) {
              this.toggleShowHidePass(!this.form.smtpRelay)
            }
            if (this.hasModuleCustomLogo && this.fileLight && this.fileLight.b64 && this.fileLight.name) {
              this.fileLight.b64 = payload.Logo.Contenido
            }
            if (this.hasModuleCustomLogo && this.fileDark && this.fileDark.b64 && this.fileDark.name) {
              this.fileDark.b64 = payload.LogoDark.Contenido
            }
            await this.$store.dispatch('app/getColors')
            await this.$store.dispatch('app/updateFrontColors')
            this.resetControlFormChanges()
            const response = await applyClientPersonalizationTemplate({ idDistribuidor: this.id }, clients)
            if (response.blnError === true) {
              this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
            } else {
              this.doFeedback('Clientes actualizados correctamente', 'success')
              this.resetControlFormChanges()
            }
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    UpdateClientsWithSelected: function (formName, clients) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            idDistribuidor: this.id,
            idClientes: clients,

            checkLogo: this.valuesCheckbox.fileLight,
            checkColor: this.valuesCheckbox.color,
            checkLogoDark: this.valuesCheckbox.fileDark,
            checkConfigSMTP: this.valuesCheckbox.Smtp,

            Logo: this.hasModuleCustomLogo && this.fileLight && this.fileLight.b64 && this.fileLight.name
              ? {
                Contenido: this.fileLight.b64,
                Extension: this.getExtensionFromFile(this.fileLight.name)
              } 
              : null,
            LogoDark: this.hasModuleCustomLogo && this.fileDark && this.fileDark.b64 && this.fileDark.name
              ? {
                Contenido: this.fileDark.b64,
                Extension: this.getExtensionFromFile(this.fileDark.name)
              }
              : null,
            Color: this.hasModuleCustomColors ? this.colorSelected : null,
            ConfigSMTP: (this.hasModuleCustomSMTPCliente || this.hasModuleCustomSMTPZerocoma) 
              ? {
                Activo: this.form.smtpMain,
                Servidor: this.form.smtpServer,
                UsrDefecto: this.form.smtpFrom,
                Puerto: this.form.smtpPort,
                SSL: this.form.smptSSL,
                OAuth2: this.form.smptOAuth2,
                Relay: this.form.smtpRelay,
                ClientId: this.form.smptClientId,
                TenantId: this.form.smptTenantId,
                Usuario: this.form.smtpUser,
                Password: this.form.smtpPass,
              }
              : null,
            PlantillasCorreos: this.hasModuleCustomMails 
              ? {
                AsuntoAvisoNuevaNotificacion: this.form.asuntoMailNew,
                AsuntoAvisoDescargaNotificacion: this.form.asuntoMailDownload,
                AsuntoAvisoNotificacionesDiarias: this.form.asuntoMailAviso,
                AsuntoAvisoNotificacionTramitada: this.form.asuntoMailTramit,
                AsuntoAvisoNotificacionVinculada: this.form.asuntoMailVinc,
                AsuntoAvisoNotificacionVinculadaEnlace: this.form.asuntoMailVincEnlace,
                AsuntoAvisoNotificacionEnvioManual: this.form.asuntoMailManual,
                AsuntoUsuarioNuevo: this.form.asuntoMailNuevoUsuario,
                AsuntoRecuperacionPassword: this.form.asuntoMailRecuperacionPass,
                AsuntoDobleAuth: this.form.asuntoMailDobleAuth,
                AsuntoAvisoOtros: this.form.asuntoMailOtrosAvisos,
                AsuntoFinWizard: this.form.asuntoMailFinWizard,
                AsuntoAvisoEspacioSuperado: this.form.asuntoMailEspacio,
                AsuntoAvisoNotificacionesSuperadas: this.form.asuntoMailNeos,
                AsuntoAvisoSMSSuperado: this.form.asuntoMailSMS,
                CuerpoAvisoNuevaNotificacion: this.gettextEditorCustomMailNew,
                CuerpoAvisoDescargaNotificacion: this.gettextEditorCustomMailDownload,
                CuerpoAvisoNotificacionesDiarias: this.gettextEditorCustomMailAviso,
                CuerpoAvisoNotificacionTramitada: this.gettextEditorCustomMailTramit,
                CuerpoAvisoNotificacionVinculada: this.gettextEditorCustomMailVinc,
                CuerpoAvisoNotificacionVinculadaEnlace: this.gettextEditorCustomMailVincEnlace,
                CuerpoAvisoNotificacionEnvioManual: this.gettextEditorCustomMailManual,
                CuerpoUsuarioNuevo: this.gettextEditorCustomMailNuevoUsuario,
                CuerpoRecuperacionPassword: this.gettextEditorCustomMailRecuperacionPass,
                CuerpoDobleAuth: this.gettextEditorCustomMailDobleAuth,
                CuerpoAvisoOtros: this.gettextEditorCustomMailOtrosAvisos,
                CuerpoFinWizard: this.gettextEditorCustomMailFinWizard,
                CuerpoAvisoEspacioSuperado: this.gettextEditorCustomMailEspacio,
                CuerpoAvisoNotificacionesSuperadas: this.gettextEditorCustomMailNeos,
                CuerpoAvisoSMSSuperado: this.gettextEditorCustomMailSMS,

                checkAsuntoAvisoNuevaNotificacion: this.valuesCheckbox.asuntoMailNew,
                checkAsuntoAvisoDescargaNotificacion: this.valuesCheckbox.asuntoMailDownload,
                checkAsuntoAvisoNotificacionesDiarias: this.valuesCheckbox.asuntoMailAviso,
                checkAsuntoAvisoNotificacionTramitada: this.valuesCheckbox.asuntoMailTramit,
                checkAsuntoAvisoNotificacionVinculada: this.valuesCheckbox.asuntoMailVinc,
                checkAsuntoAvisoNotificacionVinculadaEnlace: this.valuesCheckbox.asuntoMailVincEnlace,
                checkAsuntoAvisoNotificacionEnvioManual: this.valuesCheckbox.asuntoMailManual,
                checkAsuntoUsuarioNuevo: this.valuesCheckbox.asuntoMailNuevoUsuario,
                checkAsuntoRecuperacionPassword: this.valuesCheckbox.asuntoMailRecuperacionPass,
                checkAsuntoDobleAuth: this.valuesCheckbox.asuntoMailDobleAuth,
                checkAsuntoAvisoOtros: this.valuesCheckbox.asuntoMailOtrosAvisos, 
                // checkAsuntoFinWizard: this.valuesCheckbox.asuntoMailFinWizard, 
                checkAsuntoAvisoEspacioSuperado: this.valuesCheckbox.asuntoMailEspacio,
                checkAsuntoAvisoNotificacionesSuperadas: this.valuesCheckbox.asuntoMailNeos,
                checkAsuntoAvisoSMSSuperado: this.valuesCheckbox.asuntoMailSMS,
                checkCuerpoAvisoNuevaNotificacion: this.valuesCheckbox.contentTextEditorDefaultNew,
                checkCuerpoAvisoDescargaNotificacion: this.valuesCheckbox.contentTextEditorDefaultDownload,
                checkCuerpoAvisoNotificacionesDiarias: this.valuesCheckbox.contentTextEditorDefaultAviso,
                checkCuerpoAvisoNotificacionTramitada: this.valuesCheckbox.contentTextEditorDefaultTramit,
                checkCuerpoAvisoNotificacionVinculada: this.valuesCheckbox.contentTextEditorDefaultVinc,
                checkCuerpoAvisoNotificacionVinculadaEnlace: this.valuesCheckbox.contentTextEditorDefaultVincEnlace,
                checkCuerpoAvisoNotificacionEnvioManual: this.valuesCheckbox.contentTextEditorDefaultManual,
                checkCuerpoUsuarioNuevo: this.valuesCheckbox.contentTextEditorDefaultNuevoUsuario,
                checkCuerpoRecuperacionPassword: this.valuesCheckbox.contentTextEditorDefaultRecuperacionPass,
                checkCuerpoDobleAuth: this.valuesCheckbox.contentTextEditorDefaultDobleAuth,
                checkCuerpoAvisoOtros: this.valuesCheckbox.contentTextEditorDefaultOtrosAvisos, 
                // checkCuerpoFinWizard: this.valuesCheckbox.contentTextEditorDefaultFinWizard, 
                checkCuerpoAvisoEspacioSuperado: this.valuesCheckbox.contentTextEditorDefaultEspacio,
                checkCuerpoAvisoNotificacionesSuperadas: this.valuesCheckbox.contentTextEditorDefaultNeos,
                checkCuerpoAvisoSMSSuperado: this.valuesCheckbox.contentTextEditorDefaultSMS,
              } 
              : null,
          }
          this.toggleDialogLink()
          const response = await applyClientPersonalizationKeys({ idDistribuidor: this.id }, params)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Clientes actualizados correctamente', 'success')
            this.resetControlFormChanges()
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      if (this.isFromClient) this.$router.push({ name: 'configurations/distributors/details', params: this.id })
      else this.$router.push({ name: 'configurations/clients' })
    },
    downloadDataLogo: async function (id) {
      try {
        const template = await getLogoCustomTemplate({ idDistribuidor: this.id })
        if (template.blnError === true) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } 
      return null
    },
    downloadDataColors: async function () {
      try {
        const response = await getColorsCustomTemplate({ idDistribuidor: this.id })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          return response
        }
      } catch (error) {
        this.doFeedback()
      } 
      return null
    },
    downloadDataSmtp: async function (id) {
      try {
        const template = await getConfigSMTPTemplate({ idDistribuidor: this.id })
        if (template.blnError === true) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } 
      return null
    },
    downloadDataCorreos: async function (id) {
      try {
        const template = await getConfigCorreosTemplate({ idDistribuidor: this.id })
        if (template.blnError === true) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } 
      return null
    },
    downloadDataCorreosTags: async function (id) {
      try {
        const template = await getConfigCorreosTags({ idCliente: this.id })
        if (template.blnError === true) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } 
      return null
    },
    setDataLogo: function (data) {
      if (data) {
        if (data.Logo?.Contenido) this.croppedLight = true
        this.fileLight.b64 = data.Logo?.Contenido 
        this.fileLight.name = data.Logo 
          ? 'logo-claro.' + data.Logo?.Extension 
          : null
        if (data.LogoDark?.Contenido) this.croppedDark = true
        this.fileDark.b64 = data.LogoDark?.Contenido
        this.fileDark.name = data.LogoDark
          ? 'logo-oscuro.' + data.LogoDark?.Extension
          : null
      }
      this.resetControlFormChanges()
    },
    setDataColors (data) {
      if (data) {
        this.colorSelected = data.Color
      }
      this.resetControlFormChanges()
    },
    setDataSmtp: function (data) {
      if (data) {
        this.form.smtpMain = data.Activo
        this.form.smtpServer = data.Servidor
        this.form.smtpFrom = data.UsrDefecto
        this.form.smtpPort = data.Puerto
        this.form.smptSSL = data.SSL
        this.form.smptClientId = data.ClientId
        this.form.smptTenantId = data.TenantId
        this.form.smtpUser = data.Usuario
        this.form.smptOAuth2 = !(!data.ClientId && !data.TenantId)
        this.form.smtpRelay = data.Relay
        this.toggleShowHidePass(!this.form.smtpRelay)
        this.showTestHotFolder = true
      } else {
        this.form.smtpMain = false
        this.visibleEditPass = false
        this.disableEditPass = false
      }
      this.resetControlFormChanges()
    },
    setDataCorreos: function (data) {
      if (data) {
        this.form.asuntoMailNew = data.AsuntoAvisoNuevaNotificacion
        this.form.asuntoMailDownload = data.AsuntoAvisoDescargaNotificacion
        this.form.asuntoMailAviso = data.AsuntoAvisoNotificacionesDiarias
        this.form.asuntoMailTramit = data.AsuntoAvisoNotificacionTramitada
        this.form.asuntoMailVinc = data.AsuntoAvisoNotificacionVinculada
        this.form.asuntoMailVincEnlace = data.AsuntoAvisoNotificacionVinculadaEnlace
        this.form.asuntoMailManual = data.AsuntoAvisoNotificacionEnvioManual
        this.form.asuntoMailNuevoUsuario = data.AsuntoUsuarioNuevo
        this.form.asuntoMailRecuperacionPass = data.AsuntoRecuperacionPassword
        this.form.asuntoMailDobleAuth = data.AsuntoDobleAuth
        this.form.asuntoMailOtrosAvisos = data.AsuntoAvisoOtros 
        this.form.asuntoMailFinWizard = data.AsuntoFinWizard
        this.form.asuntoMailEspacio = data.AsuntoAvisoEspacioSuperado
        this.form.asuntoMailNeos = data.AsuntoAvisoNotificacionesSuperadas
        this.form.asuntoMailSMS = data.AsuntoAvisoSMSSuperado
          
        // Contenido
        this.contentTextEditorDefaultNew = data.CuerpoAvisoNuevaNotificacion
        this.contentTextEditorDefaultDownload = data.CuerpoAvisoDescargaNotificacion
        this.contentTextEditorDefaultAviso = data.CuerpoAvisoNotificacionesDiarias
        this.contentTextEditorDefaultTramit = data.CuerpoAvisoNotificacionTramitada
        this.contentTextEditorDefaultVinc = data.CuerpoAvisoNotificacionVinculada
        this.contentTextEditorDefaultVincEnlace = data.CuerpoAvisoNotificacionVinculadaEnlace
        this.contentTextEditorDefaultManual = data.CuerpoAvisoNotificacionEnvioManual
        this.contentTextEditorDefaultNuevoUsuario = data.CuerpoUsuarioNuevo
        this.contentTextEditorDefaultRecuperacionPass = data.CuerpoRecuperacionPassword
        this.contentTextEditorDefaultDobleAuth = data.CuerpoDobleAuth
        this.contentTextEditorDefaultOtrosAvisos = data.CuerpoAvisoOtros 
        this.contentTextEditorDefaultFinWizard = data.CuerpoFinWizard
        this.contentTextEditorDefaultEspacio = data.CuerpoAvisoEspacioSuperado
        this.contentTextEditorDefaultNeos = data.CuerpoAvisoNotificacionesSuperadas
        this.contentTextEditorDefaultSMS = data.CuerpoAvisoSMSSuperado
      }
      this.resetControlFormChanges()
    },
    setDataCorreosTags: function (data) {
      if (data) {
        // Tags
        this.tagsCustomMailNew = data.filter(x => x.Nombre === 'AvisoNuevaNotificacion')[0].Tags
        this.tagsCustomMailDownload = data.filter(x => x.Nombre === 'AvisoDescargaNotificacion')[0].Tags
        this.tagsCustomMailAviso = data.filter(x => x.Nombre === 'AvisoNotificacionesDiarias')[0].Tags
        this.tagsCustomMailTramit = data.filter(x => x.Nombre === 'AvisoNotificacionTramitada')[0].Tags
        this.tagsCustomMailVinc = data.filter(x => x.Nombre === 'AvisoNotificacionVinculada')[0].Tags
        this.tagsCustomMailVincEnlace = data.filter(x => x.Nombre === 'AvisoNotificacionVinculadaEnlace')[0].Tags
        this.tagsCustomMailManual = data.filter(x => x.Nombre === 'AvisoNotificacionEnvioManual')[0].Tags
        this.tagsCustomMailNuevoUsuario = data.filter(x => x.Nombre === 'UsuarioNuevo')[0].Tags
        this.tagsCustomMailRecuperacionPass = data.filter(x => x.Nombre === 'RecuperacionPassword')[0].Tags
        this.tagsCustomMailDobleAuth = data.filter(x => x.Nombre === 'DobleAuth')[0].Tags
        this.tagsCustomMailOtrosAvisos = data.filter(x => x.Nombre === 'AvisoOtros')[0].Tags 
        this.tagsCustomMailFinWizard = data.filter(x => x.Nombre === 'AvisoFinWizard')[0].Tags 
        this.tagsCustomMailEspacio = data.filter(x => x.Nombre === 'AvisoEspacioSuperado')[0].Tags
        this.tagsCustomMailNeos = data.filter(x => x.Nombre === 'AvisoNotificacionesSuperadas')[0].Tags
        this.tagsCustomMailSMS = data.filter(x => x.Nombre === 'AvisoSMSSuperado')[0].Tags
      }
      this.resetControlFormChanges()
    }
  }
}
</script>
